import { SystemCode } from '@/api'
import { DisplayMethod } from '@/types'

export interface BibliographySearchTooliRequest {
  displayMethod: DisplayMethod
  searchMethodAnd: boolean
  displayBranchCode: SystemCode
  title1: string
  title1Not: boolean
  title2: string
  title2Not: boolean
  author1: string
  author1Not: boolean
  author2: string
  author2Not: boolean
  subject1: string
  subject1Not: boolean
  subject2: string
  subject2Not: boolean
  series: string
  seriesNot: boolean
  publisher: string
  publisherNot: boolean
  classNo: string
  publishedYearFrom: string
  publishedYearTo: string
  freeWord: string
  _saveHistory?: boolean
}

export function BibliographySearchTooliRequestToJSON(
  value: BibliographySearchTooliRequest
): any {
  return {
    display_method: value.displayMethod,
    search_method_and: value.searchMethodAnd ?? undefined,
    display_branch_code:
      value.displayBranchCode.code !== ''
        ? value.displayBranchCode.code
        : undefined,
    title1: value.title1 !== '' ? value.title1 : undefined,
    title1_not: value.title1 !== '' ? value.title1Not : undefined,
    title2: value.title2 !== '' ? value.title2 : undefined,
    title2_not: value.title2 !== '' ? value.title2Not : undefined,
    author1: value.author1 !== '' ? value.author1 : undefined,
    author1_not: value.author1 !== '' ? value.author1Not : undefined,
    author2: value.author2 !== '' ? value.author2 : undefined,
    author2_not: value.author2 !== '' ? value.author2Not : undefined,
    subject1: value.subject1 !== '' ? value.subject1 : undefined,
    subject1_not: value.subject1 !== '' ? value.subject1Not : undefined,
    subject2: value.subject2 !== '' ? value.subject2 : undefined,
    subject2_not: value.subject2 !== '' ? value.subject2Not : undefined,
    series: value.series !== '' ? value.series : undefined,
    series_not: value.series !== '' ? value.seriesNot : undefined,
    publisher: value.publisher !== '' ? value.publisher : undefined,
    publisher_not: value.publisher !== '' ? value.publisherNot : undefined,
    class_no: value.classNo !== '' ? value.classNo : undefined,
    published_year_from:
      value.publishedYearFrom !== '' ? value.publishedYearFrom : undefined,
    published_year_to:
      value.publishedYearTo !== '' ? value.publishedYearTo : undefined,
    free_word: value.freeWord !== '' ? value.freeWord : undefined,
    _save_history: value._saveHistory ?? undefined
  }
}
